import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FilterConstants } from "src/app/constants/filterConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { UsuarioMantenimiento } from "../../models/usuario-mantenimiento";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { MaintenanceUserService } from "../../core/services/maintenance-user.service";
import { SweetAlertService } from "../../core/services/sweet-alert.service";
import { ActivatedRoute } from "@angular/router";
import { ListValueService } from "src/app/core/services/list-value.service";
import { TokenService } from "src/app/core/services/token.service";
import { CommonService } from "src/app/core/services/common.service";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { Options } from "src/app/shared/filters/models/filters.model";
import { ScreenConstants } from "src/app/constants/screenId.constants";

@Component({ templateUrl: "./list-users.component.html" })
export class ListUsersComponent implements OnInit {
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  public filtersTable;
  public filtersSearch = "";

  public listUsers: UsuarioMantenimiento[];
  filterList = FilterConstants.maintenanceUser;
  tableList = TableConstants.maintenanceUser;
  routing = RoutingConstants.maintenanceUser;
  options: Options = TableConstants.NotShowArrowUpDownAndShowDownloadReport;
  showFilterButtons: boolean = false;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  filtersTableJSON;
  public operation: string;

  usuario: UsuarioMantenimiento = {
    usId: undefined,
    usNombre: undefined,
    usApellido1: undefined,
    usApellido2: undefined,
    usEmail: undefined,
    usTelefono: undefined,
    usPwd: undefined,
    usObservaciones: undefined,
    usConcesionario: undefined,
    usPerfil: undefined,
  };

  lists = {
    tableList: [],
    concesionarioList: [],
    perfilList: [],
  };

  perfilLoaded = false;
  concesionarioLoaded = false;
  showTableFilter = false;

  constructor(
    private listValueService: ListValueService,
    private maintenanceUserService: MaintenanceUserService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private sweetAlertService: SweetAlertService,
    private tokenService: TokenService
  ) {
    this.options.style = { "min-width": "1320px" };
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      this.routing.id,
      ScreenConstants.admSistemas.usuarios
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
  }
  ngOnInit(): void {
    this.operation = this.activatedRoute.data["_value"]["operation"];

    this.loadInitialList();

    this.getConcessionaireList();
    this.getPerfilesList();
  }

  loadInitialList(): void {
    let filters = this.commonService.concatFilters(
      this.filtersTable,
      this.filtersSearch
    );
    this.maintenanceUserService.list(filters).subscribe(
      (data) => {
        this.listUsers = data["content"];
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];
        if (data["content"] && data["content"].length == 0) {
          this.toastrAlertService.toastrWarning(
            "No hay ningún resultado con la búsqueda indicada"
          );
          this.numPages = 1;
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje
            ? err.error.mensaje
            : "Error al cargar lista de usuarios"
        );
      }
    );
  }

  getConcessionaireList() {
    this.listValueService.listaConcesionarios().subscribe(
      (data) => {
        this.filterList[6]["selectorConf"]["dataList"] = data;
        this.concesionarioLoaded = true;
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje
            ? err.error.mensaje
            : "Error al cargar lista concesionarios"
        );
      }
    );
  }

  getPerfilesList() {
    this.listValueService.listaPerfiles().subscribe(
      (data) => {
        this.filterList[5]["selectorConf"]["dataList"] = data;
        this.perfilLoaded = true;
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje
            ? err.error.mensaje
            : "Error al cargar lista concesionarios"
        );
      }
    );
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.loadInitialList();
  }

  changeValue(event) {
    this.usuario[event.target.name] = event.target.value;
  }

  removeElements(ids: string[]) {
    this.maintenanceUserService.deleteUsuario(ids).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess("Usuario/s eliminado/s");
        this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
          this.routing.id,
          ScreenConstants.admSistemas.usuarios
        );
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadInitialList();
      },
      (err) => {
        this.toastrAlertService.toastrFail(
          err.error.mensaje ? err.error.mensaje : "Error al eliminar usuario/s"
        );
      }
    );
  }

  buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadInitialList();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          this.showFilterButtons = false;
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }

  downloadReport(value: string) {
    this.sweetAlertService.sweetAlertLoading();
    this.maintenanceUserService.downloadReport().subscribe(
      (data) => {
        this.commonService.downloadFile(data, "Reporte_usuarios");
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastFailBlob(err.error);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }
}
